<template>
  <v-app>
    <!-- AuthComponent сам решает, показывать ли логин или контент -->
    <AuthComponent/>
  </v-app>
</template>

<script>
import AuthComponent from "@/components/AuthComponent.vue"

export default {
  name: "App",
  components: {
    AuthComponent,
  },
  mounted() {
    (() => {
      let h = -1;
      let win = null;

      const sendExpand = () => {
        if (typeof win != 'undefined' && win) {
          const scrollHeight = document.documentElement.getBoundingClientRect().height;
          if (scrollHeight !== h) {
            h = scrollHeight;
            const sendObject = {
              height: h
            };
            win.postMessage(sendObject, '*');
          }
        }
      };

      window.addEventListener('load', () => {
        win = parent;
        sendExpand();
      });
      setInterval(sendExpand, 250);
    })();
  }
}
</script>
